<template>
  <img
    v-if="img"
    class="ui-icon"
    :style="imgStyle"
    :src="isExternalPath ? name : getImageUrl('assets/icon/svg/' + name + '.svg')"
    alt=""
  />
  <i v-else class="ui-icon" :style="iconStyle" @click="emit('click', $event)" />
</template>

<script setup>
import { computed } from 'vue'
import { getImageUrl } from 'common/functions'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  isExternalPath: {
    type: Boolean,
    default: false,
  },
  height: {
    type: [String, Number],
    default: null,
  },
  width: {
    type: [String, Number],
    default: null,
  },
  size: {
    type: [String, Number],
    default: null,
  },
  color: {
    type: String,
    default: 'currentColor',
  },
  img: Boolean,
})

const emit = defineEmits(['click'])

const iconStyle = computed(() => {
  const height = props.size || props.height
  const width = props.size || props.width

  try {
    const url = props.isExternalPath ? props.name : getImageUrl(`assets/icon/svg/${props.name}.svg`)
    const maskImage = `url("${url}")`

    const result = {
      '-webkit-mask-image': maskImage,
      'mask-image': maskImage,
      background: props.color,
    }

    if (height) {
      result.height = `${height}px`
    }

    if (width) {
      result.width = `${width}px`
    }

    return result
  } catch {
    console.error(`Could not load icon '${props.name}'`)

    return {
      height: `${props.height}px`,
      width: `${props.width}px`,
    }
  }
})

const imgStyle = computed(() => {
  return {
    height: `${props.size || props.height}px`,
    width: `${props.size || props.width}px`,
  }
})
</script>

<style lang="scss">
.ui-icon {
  display: inline-block;

  -webkit-mask-size: contain;
  mask-size: contain;

  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;

  -webkit-mask-position: center;
  mask-position: center;

  width: 24px;
  height: 24px;
}
</style>
